import { render, staticRenderFns } from "./FormContactV2.vue?vue&type=template&id=5cfce2d3"
import script from "./FormContactV2.vue?vue&type=script&lang=js"
export * from "./FormContactV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports